import { RequestOptions } from '@plus-int/acq-toolkit';
import { getGeoReplacementHeaders } from '@funtech-int/i18n-geo-widget/sdk';
import { fromBrowser } from '@funtech-int/i18n-geo-widget/sdk/fromBrowser';

import { Environment } from '@kinopoisk-int/kp-environment';

export function offersRequester<T>({ url, headers, ...rest }: RequestOptions): Promise<T> {
    return fetch(url, {
        ...rest,
        credentials: 'include',
        headers: {
            ...headers,
            ...getGeoReplacementHeaders(fromBrowser),
        },
    }).then((data) => data.json());
}

export function getPlusPaymentEnvironment(
    environment: Environment
): 'production' | 'prestable' | 'testing' {
    if (environment === Environment.Production) {
        return 'production';
    }
    if (environment === Environment.Prestable) {
        return 'prestable';
    }
    return 'testing';
}
